<template>
  <div class="row">
    <div class="col-12">
      <div class="row mt-2">
        <div class="col-3">
          <button @click="show_record_company" class="btn orcaBtn grey_bg sm_btn w-100 mb-3" data-toggle="tooltip" title="All">ALL</button>
        </div>
        <div class="col-3">
          <button @click="show_record_company" class="btn orcaBtn grey_bg sm_btn w-100 mb-3" data-toggle="tooltip" title="All">Gold</button>
        </div>
        <div class="col-3">
          <button @click="show_record_company" class="btn orcaBtn grey_bg sm_btn w-100 mb-3" data-toggle="tooltip" title="All">Silver</button>
        </div>
        <div class="col-3">
          <button @click="show_record_company" class="btn orcaBtn grey_bg sm_btn w-100 mb-3" data-toggle="tooltip" title="All">Bronze</button>
        </div>
        <div class="col-12">
          <h3 class="mb-0 text-center text-uppercase">You are currently viewing XXX companies in your pipeline</h3>
        </div>
      </div>
    </div>
    <div class="col-12" style="overflow: hidden">



      <kanban-board :stages="stages" :blocks="blocks" :config="config" :class="'kanban'" @update-block="updateBlock">
        <div v-for="stage in stages" :slot="stage" :key="stage">
          <h2>{{ stage }}</h2>
          <p class="mb-0" style="position: absolute; top: 5px; right: 16px;">{{stage_counts[stage]}}</p>
        </div>
        <div v-for="block in blocks" :slot="block.id" :key="block.id" :class="['pipeline_block', block.pipeline_opportunity_size.value]">
          <!--        <span v-if="block.status !== 'live' && block.status !== 'contract-sent' && block.status !== 'contract-signed'" class="handle">+</span>-->
          <!--        <div>-->
          <!--          <strong>id:</strong> {{ block.id }}-->
          <!--        </div>-->
          <div style="display: block">
            <h5 style="color: #333333; font-size: 0.8rem;">{{ block.company_name }}</h5>
            <button @click="show_record_company" class="btn orcaBtn greenBtn sm_btn" data-toggle="tooltip" title="View"
                    style="display: inline-block; vertical-align: top; margin-right: 5px;"
            ><i class="fas fa-eye"></i></button>
            <span style="display: inline-block; vertical-align: top; color: #333333; font-size: 0.65rem;">
            <strong>Last Pipeline Update</strong>
            <br>{{block.pipeline_status_updated | formatDateTime}}
          </span>
          </div>
        </div>
      </kanban-board>
    </div>
  </div>

</template>

<script>
import vueKanban from 'vue-kanban'
import Vue from "vue";

Vue.use(vueKanban)

export default {
  name: "my_pipeline_overview",
  data() {
    return {
      stages: ['cold', 'warm', 'hot', 'live', 'lapsed'],
      stage_counts: {
        cold: 1,
        warm: 2,
        hot: 3,
        live: 4,
        lapsed: 5
      },
      blocks: [],
      config: {
        // Don't allow blocks to be moved out of the approved stage
        accepts(block, target, source) {
          return false;
          // return source.dataset.status !== 'live' && source.dataset.status !== 'contract-sent' && source.dataset.status !== 'contract-signed'
          // && target.dataset.status !== 'live'  && target.dataset.status !== 'contract-sent' && target.dataset.status !== 'contract-signed'
        },
        // moves(block, target, handle) {
        //   return handle.classList.contains('handle');
        // }
      }
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'sales_service/pipeline/my_pipeline', {
      params: {
        user_id: this.$store.state.auth.me.id
      }
    }).then(res => {
      // console.log(res.data)
      this.blocks = res.data;
    })
  },
  methods: {
    updateBlock(id, status) {
      this.blocks.find(b => b.id === Number(id)).status = status;
    },
    show_record_company() {

    }
  }
}
</script>

<style scoped>

</style>
